/**
 * API-Football `league.country` strings → flagcdn codes (not “two flags”: domestic leagues need names too).
 * `xx` = show no flag. When country is World/empty, `resolveLeagueCountryCodeForFlag` also checks league name.
 */

export const LEAGUE_COUNTRY_NAME_TO_FLAG_CODE: Record<string, string> = {
  // UK home nations
  england: 'gb-eng',
  scotland: 'gb-sct',
  wales: 'gb-wls',
  'northern ireland': 'gb-nir',

  // Common API-Football / football data names
  spain: 'es',
  italy: 'it',
  germany: 'de',
  france: 'fr',
  netherlands: 'nl',
  portugal: 'pt',
  belgium: 'be',
  turkey: 'tr',
  greece: 'gr',
  austria: 'at',
  switzerland: 'ch',
  poland: 'pl',
  ukraine: 'ua',
  russia: 'ru',
  croatia: 'hr',
  serbia: 'rs',
  'czech republic': 'cz',
  czechia: 'cz',
  romania: 'ro',
  hungary: 'hu',
  sweden: 'se',
  norway: 'no',
  denmark: 'dk',
  finland: 'fi',
  ireland: 'ie',
  iceland: 'is',
  israel: 'il',
  brazil: 'br',
  argentina: 'ar',
  mexico: 'mx',
  usa: 'us',
  'united states': 'us',
  canada: 'ca',
  japan: 'jp',
  'south korea': 'kr',
  korea: 'kr',
  australia: 'au',
  'saudi arabia': 'sa',
  /** Common abbreviation */
  ksa: 'sa',
  /** Some feeds use league label as country for Saudi Pro League */
  'saudi pro league': 'sa',
  /** Informal / short label for Saudi Pro League (not Belgian Pro League — that uses country Belgium) */
  'pro league': 'sa',
  egypt: 'eg',
  'south africa': 'za',
  colombia: 'co',
  chile: 'cl',
  uruguay: 'uy',
  ecuador: 'ec',
  peru: 'pe',
  paraguay: 'py',
  bolivia: 'bo',
  venezuela: 've',
  china: 'cn',
  india: 'in',

  // Cups / regions — no single flag (omit via xx sentinel in helper)
  world: 'xx',
  /** European club / UEFA competitions (API-Football often uses these for UCL, UEL, etc.) */
  europe: 'eu',
  uefa: 'eu',
  european: 'eu',
  /** Same intent as "europe" in some API payloads */
  eu: 'eu',
  asia: 'xx',
  africa: 'xx',
  'south america': 'xx',
  international: 'xx',
};

/** If `league.country` is useless (e.g. World), match `league.name` for UEFA club comps → EU flag */
export const EU_LEAGUE_NAME_SUBSTRINGS: readonly string[] = [
  'uefa champions league',
  'uefa europa league',
  'uefa europa conference league',
  'uefa conference league',
  'uefa conference',
  'uefa super cup',
  'uefa youth league',
  // API-Football sometimes omits the "UEFA" prefix
  'champions league',
  'europa league',
  'europa conference league',
  'conference league',
];

/**
 * Exact normalized league display names → flagcdn codes when `league.country` is missing or wrong.
 * Keys are trimmed lowercased league names with collapsed spaces (same as league flag helper).
 */
export const LEAGUE_DISPLAY_NAME_TO_FLAG_CODE: Record<string, string> = {
  'premier league': 'gb-eng',
};
